import { useMemo, useState } from "react";
import ConfettiExplosion from "react-confetti-explosion";

import DirectionButton from "@components/buttons/DirectionButton";
import styles from "@components/carePlan/CarePlan.module.css";
import Goal from "@components/carePlan/Goal";
import { CarePlanSectionEnum } from "@typing/Enums";
import { GetJourneyWithPlanQuery, GoalStatusEnum } from "@typing/Generated";
import { Direction } from "@typing/Models";
import { sortByPosition } from "@utils/modelUtils";

type Props = {
  completed: boolean;
  handleCurrentSectionChange: (section: CarePlanSectionEnum, direction: Direction) => void;
  journey: GetJourneyWithPlanQuery["journey"];
};

const Archive = ({ completed, handleCurrentSectionChange, journey }: Props) => {
  const [isExploding, setIsExploding] = useState(false);

  const goals = useMemo(() => {
    const goals = sortByPosition(
      journey.goals.filter(g => g.archived).filter(goal => goal.status !== GoalStatusEnum.DRAFT)
    );
    if (journey.carePlanPublishedAt) {
      return goals;
    } else {
      return goals.filter(goal => goal.author.__typename !== "Expert");
    }
  }, [journey.carePlanPublishedAt, journey.goals]);

  return (
    <div className={`padding-40-bottom ${styles.mobileSpacing}`}>
      <div className="ion-hide-lg-down">
        <DirectionButton
          direction="back"
          onClick={() => handleCurrentSectionChange(CarePlanSectionEnum.CARE_PLAN, "left")}
        />
      </div>

      {isExploding && (
        <ConfettiExplosion
          colors={["#5f49d3", "#82d4e8", "#ff7673", "#FAC7F3", "#F7DBF4"]}
          duration={2500}
          force={0.6}
          particleCount={85}
          width={1000}
        />
      )}

      {goals.map(goal => (
        <Goal
          completed={completed}
          goal={goal}
          handleCurrentSectionChange={handleCurrentSectionChange}
          journey={journey}
          key={goal.id}
          setIsExploding={setIsExploding}
        />
      ))}
    </div>
  );
};

export default Archive;
